export const entityName = 'dataStoreClassifications';
export const idAttribute = 'id';
